var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3637 0.36361C8.71517 0.0121381 9.28502 0.0121381 9.63649 0.36361L13.6365 4.36361C13.988 4.71508 13.988 5.28493 13.6365 5.6364C13.285 5.98787 12.7152 5.98787 12.3637 5.6364L9.9001 3.1728V13C9.9001 13.4971 9.49715 13.9 9.0001 13.9C8.50304 13.9 8.1001 13.4971 8.1001 13V3.1728L5.63649 5.6364C5.28502 5.98787 4.71517 5.98787 4.3637 5.6364C4.01223 5.28493 4.01223 4.71508 4.3637 4.36361L8.3637 0.36361ZM1.0001 12.1C1.49715 12.1 1.9001 12.5029 1.9001 13V14C1.9001 15.1598 2.84029 16.1 4.0001 16.1H14.0001C15.1599 16.1 16.1001 15.1598 16.1001 14V13C16.1001 12.5029 16.503 12.1 17.0001 12.1C17.4972 12.1 17.9001 12.5029 17.9001 13V14C17.9001 16.154 16.1541 17.9 14.0001 17.9H4.0001C1.8462 17.9 0.100098 16.154 0.100098 14V13C0.100098 12.5029 0.503041 12.1 1.0001 12.1Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.f3e8e0d80183d4616d786d6ea2bd9b63.svg";
export { ForwardRef as ReactComponent };